var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16a1 1 0 0 1 1 1v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a3 3 0 0 1 2.122.879l3.211 3.216a1 1 0 0 1 0 1.414 1 1 0 0 1-1.414 0l-2.912-2.913L13 18.016a1 1 0 0 1-2 0l.007-15.438L8.08 5.505a1 1 0 0 1-1.414-1.413L9.877.879A3 3 0 0 1 12 0"
  })));
};
export default SvgUpload;